import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setAuthUser } from '../../redux/slice/authSlice';
import { POSTRequest, validateEmail } from '../../utils';
import LoadingButton from '../common/LoadingButton';

const LoginForm = () => {
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [user, setLoginUser] = useState({
        email: '',
        password: '',
    });

    const onSubmit = async () => {
        if (user.email !== '' && validateEmail(user.email)) {
            if (user.password !== '' && user.password.length >= 8) {
                setSubmitting(true);
                try {
                    const { data, success, message } = await POSTRequest('/login', user);
                    if (success) {
                        const { id, username, name, email, role, access_token, refresh_token } =
                            data;
                        localStorage.setItem('token', access_token);
                        localStorage.setItem('refresh', refresh_token);
                        dispatch(setAuthUser({ id, username, name, email, role }));
                    } else {
                        setError(message);
                        setTimeout(() => setError(''), 3000);
                    }
                } catch (error) {
                    setError('سسٹم کام نہیں کر رہا ہے');
                    setTimeout(() => setError(''), 3000);
                }
            } else {
                setError('درست پاس ورڈ درج کریں');
                setTimeout(() => setError(''), 2000);
            }
        } else {
            setError('درست امیل درج کریں');
            setTimeout(() => setError(''), 2000);
        }
    };

    return (
        <div className='flex column justifyStart alignCenter w-100' style={{ direction: 'rtl' }}>
            <div className='flex justifyCenter alignCenter w-100'>
                <div className='card form-content'>
                    <div className='flex justifyStart alignCenter card-title'>لاگ ان کریں</div>
                    <div className='card-body'>
                        <div className='form-container'>
                            <label htmlFor='email'>
                                امیل درج کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='email'
                                id='email'
                                name='email'
                                value={user.email}
                                autoFocus='on'
                                placeholder='abc@gmail.com'
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        setLoginUser({ ...user, email: event.target.value });
                                        onSubmit();
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setLoginUser({ ...user, email: event.target.value });
                                    } else {
                                        setLoginUser({ ...user, email: '' });
                                    }
                                }}
                            />
                        </div>
                        <div className='form-container'>
                            <label htmlFor='password'>
                                پاس ورڈ درج کریں
                                <span className='required'>*</span>
                            </label>
                            <input
                                type='password'
                                id='password'
                                name='password'
                                value={user.password}
                                placeholder='xxxxxxxx'
                                minLength={8}
                                onKeyUp={(event) => {
                                    if (event.keyCode === 13) {
                                        setLoginUser({ ...user, password: event.target.value });
                                        onSubmit();
                                    }
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length > 0) {
                                        setLoginUser({ ...user, password: event.target.value });
                                    } else {
                                        setLoginUser({ ...user, password: '' });
                                    }
                                }}
                            />
                        </div>
                        <div className='form-footer'>
                            <div className='w-100'>
                                <LoadingButton
                                    btnClass='submit-button'
                                    submitting={submitting}
                                    onClick={onSubmit}
                                    label='لاگ ان'
                                    style={{ minWidth: '100%', marginTop: 16 }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {error !== '' && (
                <div
                    className='error-toast w-100'
                    style={{
                        padding: 20,
                        maxWidth: '50vw',
                        textAlign: 'center',
                        position: 'absolute',
                        bottom: 0,
                    }}
                >
                    <p style={{ color: '#ffffff' }}> {error}</p>
                </div>
            )}
        </div>
    );
};

export default LoginForm;
